import React, { useEffect, useRef } from 'react';
import { Star, StarOff } from 'lucide-react';

interface NavContextMenuProps {
  x: number;
  y: number;
  isPinned: boolean;
  onPin: () => void;
  onUnpin: () => void;
  onClose: () => void;
}

const NavContextMenu: React.FC<NavContextMenuProps> = ({ x, y, isPinned, onPin, onUnpin, onClose }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onClose();
      }
    };
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('mousedown', handleClick);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('keydown', handleKey);
    };
  }, [onClose]);

  // Keep menu within viewport
  const menuWidth = 200;
  const menuHeight = 44;
  const adjustedX = Math.min(x, window.innerWidth - menuWidth - 8);
  const adjustedY = Math.min(y, window.innerHeight - menuHeight - 8);

  return (
    <div
      ref={ref}
      style={{ position: 'fixed', top: adjustedY, left: adjustedX, zIndex: 9999 }}
      className="bg-white border border-slate-200 rounded-xl shadow-lg py-1 min-w-[180px]"
    >
      {isPinned ? (
        <button
          onClick={() => { onUnpin(); onClose(); }}
          className="flex items-center gap-2.5 w-full px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 transition-colors"
        >
          <StarOff size={15} className="text-slate-400 shrink-0" />
          Remove from Favourites
        </button>
      ) : (
        <button
          onClick={() => { onPin(); onClose(); }}
          className="flex items-center gap-2.5 w-full px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 transition-colors"
        >
          <Star size={15} className="text-amber-400 shrink-0" />
          Add to Favourites
        </button>
      )}
    </div>
  );
};

export default NavContextMenu;
